import "./crud.module.css";
import "font-awesome/css/font-awesome.min.css";
import asRestEntity from "./Common/RestEntityHOC";
import asBookingEngineEntity from "./Common/BookingEngineEntityHOC";
import BaseFilterList from "./Filter/FilterList";
import BaseFilterForm from "./Filter/FilterForm";
import baseFilterConfig from "./Filter/ModuleDefinition";

import BaseEmailTemplateList from "./EmailTemplate/EmailTemplateList";
import BaseEmailTemplateForm from "./EmailTemplate/EmailTemplateForm";

import BaseLegalInfoForm from "./LegalInfo/LegalInfoForm";
import BaseLegalInfoList from "./LegalInfo/LegalInfoList";

import BaseModificationForm from "./Modification/ModificationForm";
import BaseModificationList from "./Modification/ModificationList";

import BasePaymentTypesList from "./PaymentTypes/PaymentTypesList";
import BasePaymentTypesForm from "./PaymentTypes/PaymentTypesForm";

import BaseDisplayForm from "./Display/DisplayForm";
import BaseDisplayList from "./Display/DisplayList";

import BaseCancellationPolicyList from "./CancellationPolicy/CancellationPolicyList";
import BaseCancellationPolicyForm from "./CancellationPolicy/CancellationPolicyForm";

import BaseQuestionnaireList from "./Questionnaire/QuestionnairesList";
import BaseQuestionnaireForm from "./Questionnaire/QuestionnairesForm";

import BaseConditionsForm from "./Conditions/ConditionsForm";
import BaseConditionsList from "./Conditions/ConditionsList";

import BasePromotionsForm from "./Promotions/PromotionsForm";
import BasePromotionsList from "./Promotions/PromotionsList";
import BaseClientsList from "./CRM/Clients/ClientsList";
import BaseClientsForm from "./CRM/Clients/ClientsForm";

import BaseContractsList from "./CRM/Contracts/ContractsList";
import BaseContractsForm from "./CRM/Contracts/ContractsForm";

import BasePartnersList from "./CRM/Partners/PartnersList";
import BasePartnersForm from "./CRM/Partners/PartnersForm";

import BasePropertiesList from "./CRM/Properties/PropertiesList";
import BasePropertiesForm from "./CRM/Properties/PropertiesForm";

import BaseServicesList from "./CRM/Services/ServicesList";
import BaseServicesForm from "./CRM/Services/ServicesForm";

import CONSTANTS from "./constants";

export const FilterList = asBookingEngineEntity(asRestEntity(BaseFilterList), {
  entityName: baseFilterConfig.entityName,
  type: "LIST",
});
export const FilterForm = asBookingEngineEntity(asRestEntity(BaseFilterForm), {
  entityName: baseFilterConfig.entityName,
  type: "FORM",
});

export const EmailTemplateList = asBookingEngineEntity(asRestEntity(BaseEmailTemplateList), {
  entityName: CONSTANTS.ENTITY.EMAIL_TEMPLATE.name,
  type: "LIST",
});
export const EmailTemplateForm = asBookingEngineEntity(asRestEntity(BaseEmailTemplateForm), {
  entityName: CONSTANTS.ENTITY.EMAIL_TEMPLATE.name,
  type: "FORM",
});

export const LegalInfoList = asBookingEngineEntity(asRestEntity(BaseLegalInfoList), {
  entityName: CONSTANTS.ENTITY.LEGAL_INFO.name,
  type: "LIST",
});

export const LegalInfoForm = asBookingEngineEntity(asRestEntity(BaseLegalInfoForm), {
  entityName: CONSTANTS.ENTITY.LEGAL_INFO.name,
  type: "FORM",
});

export const ModificationList = asBookingEngineEntity(asRestEntity(BaseModificationList), {
  entityName: CONSTANTS.ENTITY.MODIFICATION.name,
  type: "LIST",
});

export const ModificationForm = asBookingEngineEntity(asRestEntity(BaseModificationForm), {
  entityName: CONSTANTS.ENTITY.MODIFICATION.name,
  type: "FORM",
});

export const PaymentTypesList = asBookingEngineEntity(
  asRestEntity(BasePaymentTypesList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.ticker}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.PAYMENT_TYPES.name, type: "LIST" }
);

export const PaymentTypesForm = asBookingEngineEntity(asRestEntity(BasePaymentTypesForm), {
  entityName: CONSTANTS.ENTITY.PAYMENT_TYPES.name,
  type: "FORM",
});

export const DisplayList = asBookingEngineEntity(asRestEntity(BaseDisplayList), {
  entityName: CONSTANTS.ENTITY.DISPLAY.name,
  type: "LIST",
});

export const DisplayForm = asBookingEngineEntity(asRestEntity(BaseDisplayForm), {
  entityName: CONSTANTS.ENTITY.DISPLAY.name,
  type: "FORM",
});

export const CancellationPolicyList = asBookingEngineEntity(
  asRestEntity(BaseCancellationPolicyList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.ticker}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.CANCELLATIONPOLICY.name, type: "LIST" }
);

export const CancellationPolicyForm = asBookingEngineEntity(
  asRestEntity(BaseCancellationPolicyForm),
  { entityName: CONSTANTS.ENTITY.CANCELLATIONPOLICY.name, type: "FORM" }
);

export const QuestionnaireForm = asBookingEngineEntity(asRestEntity(BaseQuestionnaireForm), {
  entityName: CONSTANTS.ENTITY.QUESTIONNAIRE.name,
  type: "FORM",
});

export const QuestionnaireList = asBookingEngineEntity(
  asRestEntity(BaseQuestionnaireList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.ticker}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.QUESTIONNAIRE.name, type: "LIST" }
);

export const ConditionsList = asBookingEngineEntity(
  asRestEntity(BaseConditionsList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.ticker}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.CONDITIONS.name, type: "LIST" }
);

export const ConditionsForm = asBookingEngineEntity(asRestEntity(BaseConditionsForm), {
  entityName: CONSTANTS.ENTITY.CONDITIONS.name,
  type: "FORM",
});

export const PromotionsList = asBookingEngineEntity(
  asRestEntity(BasePromotionsList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.PROMOTIONS.name, type: "LIST" }
);

export const PromotionsForm = asBookingEngineEntity(asRestEntity(BasePromotionsForm), {
  entityName: CONSTANTS.ENTITY.PROMOTIONS.name,
  type: "FORM",
});

export const ClientsList = asBookingEngineEntity(
  asRestEntity(BaseClientsList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.CLIENTS.name, type: "LIST" }
);

export const ClientsForm = asBookingEngineEntity(asRestEntity(BaseClientsForm), {
  entityName: CONSTANTS.ENTITY.CLIENTS.name,
  type: "FORM",
});

export const ContractsList = asBookingEngineEntity(
  asRestEntity(BaseContractsList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.CONTRACTS.name, type: "LIST" }
);

export const ContractsForm = asBookingEngineEntity(asRestEntity(BaseContractsForm), {
  entityName: CONSTANTS.ENTITY.CONTRACTS.name,
  type: "FORM",
});

export const PartnersList = asBookingEngineEntity(
  asRestEntity(BasePartnersList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.PARTNERS.name, type: "LIST" }
);

export const PartnersForm = asBookingEngineEntity(asRestEntity(BasePartnersForm), {
  entityName: CONSTANTS.ENTITY.PARTNERS.name,
  type: "FORM",
});
//
export const PropertiesList = asBookingEngineEntity(
  asRestEntity(BasePropertiesList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.PROPERTIES.name, type: "LIST" }
);

export const PropertiesForm = asBookingEngineEntity(asRestEntity(BasePropertiesForm), {
  entityName: CONSTANTS.ENTITY.PROPERTIES.name,
  type: "FORM",
});

export const ServicesList = asBookingEngineEntity(
  asRestEntity(BaseServicesList, {
    handleEdit: ({ event, history, hotelTicker, entityName, entity }) => {
      return history.push(`/${hotelTicker}/${entityName}/${entity.id}`);
    },
  }),
  { entityName: CONSTANTS.ENTITY.SERVICES.name, type: "LIST" }
);

export const ServicesForm = asBookingEngineEntity(asRestEntity(BaseServicesForm), {
  entityName: CONSTANTS.ENTITY.SERVICES.name,
  type: "FORM",
});
